import type { PlantManagerAsset, PlantManagerComponent } from '@e2grnd/ui-core/dist/types'
import type { ReactNode } from 'react'

import examples from './examples'
import params from './params'

export { examples, params }

export const assetComponentParamsMapFn = (pmAsset: PlantManagerAsset, pmComponent: PlantManagerComponent) => {
  if(!pmAsset) {
    return { fieldValues: {} }
  }

  console.log('Mapping asset data:\n\tAsset:', pmAsset, '\n\tComponent:', pmComponent)
  const warnings: ReactNode[] = []

  let innerDiameter
  if(!pmComponent.innerDiameter) {
    warnings.push('The selected component does not have an inner diameter defined. Thus, we calculate the inner diameter from the outer diameter and the nominal thickness.')
    if(!pmComponent.outerDiameter) {
      warnings.push('The selected component does not have an outer diameter defined.')
    } else {
      if(!pmComponent.nominalThickness) {
        warnings.push('The selected component does not have a nominal thickness defined.')
      } else {
        innerDiameter = pmComponent.outerDiameter - 2.0 * pmComponent.nominalThickness
      }
    }
  } else {
    innerDiameter = pmComponent.innerDiameter
  }

  let nominalThickness
  if(!pmComponent.nominalThickness) {
    warnings.push('The selected component does not have a nominal thickness defined.')
  } else {
    nominalThickness = pmComponent.nominalThickness
  }

  let temperature
  if(!pmComponent.circuit) {
    warnings.push('The selected component does not have a circuit defined.')
    if(!pmComponent.designTemperature) {
      warnings.push('The selected component does not have a design temperature defined.')
    }
    temperature = pmComponent.designTemperature
  } else {
    if(!pmComponent.circuit.operatingTemperature) {
      warnings.push('The selected component does not have a circuit operating temperature defined.')
    }
    temperature = pmComponent.circuit.operatingTemperature
  }

  let geomType
  if(!pmComponent.geomType) {
    warnings.push('The selected component does not have a geometry type defined.')
  } else {
    if(pmComponent.geomType === 'CY' || pmComponent.geomType === 'SP') {
      geomType = pmComponent.geomType
    } else {
      warnings.push('The selected component does not have a supported geometry type.')
    }
  }

  return {
    warnings,
    fieldValues: {
      insideDiameter: innerDiameter,
      thickness: nominalThickness,
      temperature,
      shellType: geomType,
    },
  }
}
